export default __webpack_public_path__ + "media/images/react_icons/quotation_marks-364d1f4c5893f827d78f833270fb5fef.svg";